import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';
import { useLanguage } from '../../../contexts/LanguageContext';

const DocumentShareModal = ({ isOpen, onClose, document, currentLanguage }) => {
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [sendCopy, setSendCopy] = useState(false);
  const [includeMessage, setIncludeMessage] = useState(false);
  const [message, setMessage] = useState('');

  if (!isOpen || !document) return null;

  const handleShare = () => {
    console.log('Sharing document:', {
      document: document?.name,
      email,
      sendCopy,
      message: includeMessage ? message : null
    });
    
    alert(currentLanguage === 'fr' 
      ? `Document "${document?.name}" partagé avec succès à ${email}` 
      : `تم مشاركة المستند "${document?.name}" بنجاح إلى ${email}`);
    
    onClose();
  };

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" 
      onClick={onClose}
    >
      <div 
        className="bg-card rounded-lg border border-border shadow-warm max-w-2xl w-full max-h-[90vh] overflow-y-auto"
        onClick={(e) => e?.stopPropagation()}
      >
        {/* Header */}
        <div className="sticky top-0 bg-card border-b border-border px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name="Share2" size={20} className="text-primary" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-foreground">
                {t('documents.shareDocument')}
              </h2>
              <p className="caption text-muted-foreground">{document?.name}</p>
            </div>
          </div>
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            onClick={onClose}
            aria-label={t('documents.close')}
          />
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          <Input
            label={t('documents.recipientEmail')}
            type="email"
            placeholder={currentLanguage === 'fr' ? 'exemple@email.com' : 'example@email.com'}
            value={email}
            onChange={(e) => setEmail(e?.target?.value)}
            required
          />

          <div className="space-y-3">
            <Checkbox
              label={t('documents.sendMeCopy')}
              description={t('documents.receiveCopy')}
              checked={sendCopy}
              onChange={(e) => setSendCopy(e?.target?.checked)}
            />

            <Checkbox
              label={t('documents.includeMessage')}
              description={t('documents.addCustomMessage')}
              checked={includeMessage}
              onChange={(e) => setIncludeMessage(e?.target?.checked)}
            />
          </div>

          {includeMessage && (
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                {t('documents.message')}
              </label>
              <textarea
                value={message}
                onChange={(e) => setMessage(e?.target?.value)}
                rows={4}
                placeholder={t('documents.enterMessage')}
                className="w-full px-4 py-2 bg-background border border-border rounded-md text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 resize-none"
              />
            </div>
          )}

          <div className="bg-accent/10 border border-accent/20 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={20} className="text-accent flex-shrink-0 mt-0.5" />
              <div className="text-sm text-foreground">
                <p className="font-medium mb-1">
                  {t('documents.importantInfo')}
                </p>
                <p className="text-muted-foreground">
                  {t('documents.shareInfo')}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="sticky bottom-0 bg-card border-t border-border px-6 py-4 flex items-center justify-end gap-3">
          <Button
            variant="outline"
            onClick={onClose}
          >
            {t('documents.cancel')}
          </Button>
          <Button
            variant="default"
            iconName="Send"
            iconPosition="left"
            onClick={handleShare}
            disabled={!email}
          >
            {t('documents.share')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DocumentShareModal;